import * as React from 'react';
import { WorkOrderCheckComparisonRow } from '../../utils/InvoiceUtils';

interface WorkOrderCheckComparisonTableProps {
	rows: WorkOrderCheckComparisonRow[];
	/** Severity wash for the invoice column — the side under suspicion. */
	invoiceCellClassName: string;
}

const FIELD_COLUMN_WIDTH = 'w-[140px]';

/**
 * The work-order-versus-invoice comparison, as a three column table: what the record says, and
 * what the PDF said. Only the invoice column is washed red — it is the side under suspicion.
 *
 * Shared by the confirmation modal and the inline block on the invoice screen, which draw the
 * same table with different surrounding chrome.
 */
export const WorkOrderCheckComparisonTable: React.FC<WorkOrderCheckComparisonTableProps> = ({
	rows,
	invoiceCellClassName,
}) => {
	if (!rows || rows.length === 0) {
		return null;
	}

	return (
		// The table can outgrow a narrow viewport; let it scroll rather than squeeze the columns.
		<div className="w-full overflow-x-auto border border-solid border-grey-4">
			<div className="flex min-w-[520px] flex-col">
				<div className="flex flex-row border-0 border-b border-solid border-grey-4 bg-grey-2">
					<div className={`${FIELD_COLUMN_WIDTH} bodyregular shrink-0 px-m py-s text-grey-7`}>
						Field
					</div>
					<div className="bodyregular flex-1 px-m py-s text-grey-7">Work Order</div>
					<div className="bodyregular flex-1 px-m py-s text-grey-7">Uploaded Invoice</div>
				</div>
				{rows.map((row, index) => (
					<div
						className={`flex flex-row ${
							index === rows.length - 1 ? '' : 'border-0 border-b border-solid border-grey-4'
						}`}
						key={row.key}
					>
						<div
							className={`${FIELD_COLUMN_WIDTH} bodymedium flex shrink-0 flex-col justify-center p-m text-character-primary`}
						>
							{row.label}
						</div>
						<div className="bodyregular flex-1 p-m text-grey-9">{row.workOrderValue || '—'}</div>
						<div
							className={`bodyregular flex flex-1 flex-col justify-center p-m text-character-primary ${invoiceCellClassName}`}
						>
							{row.invoiceValue || '—'}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default WorkOrderCheckComparisonTable;
